import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {
  createRuleReducer,
  offerTagsReducer,
  offerUploadStatusReducer,
  campaignSaveStatusReducer,
  templateUploadStatusReducer,
  offerDefinitionConfigReducer,
  businessUnitsReducer
} from './modules/B2BOfferModule'

export default (store) => ({
  path: 'b2b-offer-flow',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const B2BOfferModuleContainer = require('./containers/B2BOfferModule').default

      injectReducer(store, {key: 'createdRuleDetails', reducer: createRuleReducer})
      injectReducer(store, {key: 'campaignSaveStatus', reducer: campaignSaveStatusReducer})
      injectReducer(store, {key: 'offerTags', reducer: offerTagsReducer})
      injectReducer(store, {key: 'offerDefinitionConfig', reducer: offerDefinitionConfigReducer})
      injectReducer(store, {key: 'offersUploadStatus', reducer: offerUploadStatusReducer})
      injectReducer(store, {key: 'businessUnits', reducer: businessUnitsReducer})
      injectReducer(store, {key: 'templateUploadStatus', reducer: templateUploadStatusReducer})
      cb(null, B2BOfferModuleContainer)
    }, 'offerModule')
  }
})



// WEBPACK FOOTER //
// ./src/routes/B2BOfferModule/index.js